module.exports = __webpack_public_path__ + "img/logo-el_alquimista.2becc451.svg";